exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-pagination{text-align:center;padding:30px 0}", ""]);

// exports
